import { render, staticRenderFns } from "./zplist.vue?vue&type=template&id=7c8db841&scoped=true&"
import script from "./zplist.vue?vue&type=script&lang=js&"
export * from "./zplist.vue?vue&type=script&lang=js&"
import style0 from "./zplist.vue?vue&type=style&index=0&id=7c8db841&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8db841",
  null
  
)

export default component.exports